import React from 'react';
import If from 'components/if-statement';
import RevokeConfirmationMessage from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/components/users-with-access-list/components/revoke-confirmation-message';
import UserAccessList from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/components/users-with-access-list/components/user-access-list';
import useSharedRootSurface from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/hooks/use-is-shared-surface-via-parent';
import useRevokeAction from 'components/canvas/components/top-left-menu/components/share-surface-button/components/share-surface-modal/components/users-with-access-list/hooks/use-revoke-action';
import { SurfaceNodeUnion } from 'graphql/types';

export interface UsersWithAccessListProps {}

const defaultProps = {};

function UsersWithAccessList({ surface }: { surface: SurfaceNodeUnion }) {
  const sharedRootSurface = useSharedRootSurface(surface.id);

  const {
    isLoading,
    cancelRevoking,
    onRevokeConfirm,
    showConfirmationMessage,
    revokeAccess,
  } = useRevokeAction(sharedRootSurface);

  return (
    <If condition={showConfirmationMessage}>
      <If.Then>
        <RevokeConfirmationMessage
          isLoading={isLoading}
          surfaceName={surface?.name}
          sharedRootSurfaceName={sharedRootSurface?.name}
          onCancel={cancelRevoking}
          onConfirm={onRevokeConfirm}
        />
      </If.Then>
      <If.Else>
        <UserAccessList revokeAccess={revokeAccess} />
      </If.Else>
    </If>
  );
}

UsersWithAccessList.defaultProps = defaultProps;

export default UsersWithAccessList;
